module.exports = __webpack_public_path__ + "static/media/sviluppo-e-territorio.9c993ef7.png";